<template>
  <div>
    <home-header />
    <div class="content page-width">
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-2">
          <div class="personalimg">
            <img
              :src="userInfo.avatar ? userInfo.avatar : userInfo.sex === '1' ? `https://stu8.jxjypt.cn/nan.jpg` : `https://stu8.jxjypt.cn/nv.jpg`"
              width="94"
              height="94"
            />
          </div>
          <h1>
            {{ userInfo.name }}
            <span class="grade">({{ userInfo.gradeStr || userInfo.grade + '级' }})</span>
          </h1>
          <div class="margin-bottom-20 mymajor">专业：{{ userInfo.proName }}</div>
          <div class="margin-bottom-20 mymajor">登录次数：{{ userInfo.loginCount }}</div>
          <div class="margin-bottom-20 enroll-switch" v-if="showSwitchBtn">
            <a-button type="link" size="small" @click="openSwitchModal">
              <a-icon type="sync" />
              <span>切换学籍</span>
            </a-button>
          </div>
          <ul class="centerli">
            <li class="centerli-top">个人中心</li>
            <li><router-link to="/personalcenters/myinfo" active-class="active" exact>我的信息</router-link></li>
            <li v-if="$store.state.homeObj.archive_change_show != '0'">
              <router-link to="/personalcenters/changestate" active-class="active">学籍异动申请表</router-link>
            </li>
            <li v-if="$store.state.homeObj.exam_post != '0'">
              <router-link to="/personalcenters/examPost" active-class="active">缓考申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.gra_apply_enable == '1'">
              <router-link to="/graduation/apply" active-class="active">毕业或学位申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.graduate_apply_visible == '1'">
              <router-link to="/graduation/graSingleApply" active-class="active">毕业申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.degree_apply_visible == '1'">
              <router-link to="/graduation/degSingleApply" active-class="active">学位申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.doc_info_collection_show === '1'">
              <router-link to="/personalcenters/infocollect" active-class="active">信息采集</router-link>
            </li>
            <li v-if="$store.state.homeObj.unpaidTuitionFlag !== '0'">
              <router-link to="/mypersonal/tuitionfeethis" active-class="active">我的学费</router-link>
            </li>
            <li v-if="$store.state.homeObj.fee_module_visible === '1'">
              <router-link to="/personalcenters/tuitionfee" active-class="active">学费查询</router-link>
            </li>
            <li v-if="$store.state.homeObj.show_fee === '1'">
              <a class="payment-nav-link" :class="{ active: $route.path === '/personalcenters/payment' }" @click="gotoPayment">{{ homeObj.edu_fee_name }}</a>
            </li>
            <li v-if="$store.state.homeObj.exam_mode === '2'">
              <router-link to="/personalcenters/applyOfflineExam" active-class="active" exact>预约线下考试</router-link>
            </li>
            <li v-if="$store.state.homeObj.feedBack_show === '1'">
              <router-link to="/personalcenters/FeedBack" active-class="active">意见反馈</router-link>
            </li>
            <li v-if="$store.state.homeObj.photo_show === '1'">
              <router-link to="/personalcenters/getStuPhoto" active-class="active">毕业生照片采集</router-link>
            </li>
            <li v-if="$store.state.homeObj.storage_show === '1'">
              <router-link to="/personalcenters/fileStorage" active-class="active">个人云盘</router-link>
            </li>
            <li><router-link to="/personalcenters/forgetpassword" active-class="active">修改密码</router-link></li>
            <li><router-link to="/personalcenters/SecuritySetting" active-class="active">安全中心</router-link></li>
          </ul>
        </div>
        <div class="col-md-10">
          <router-view />
        </div>
      </div>
      <ul>
        <li></li>
      </ul>
    </div>
    <Foot></Foot>

    <!-- 学籍切换子组件 -->
    <EnrollmentSwitch :visible.sync="switchModalVisible" :curStuId="userInfo.id" />

    <!-- 手动触发的缴费通知弹窗 -->
    <PayNotifyModal
      :visible="payNotifyVisible"
      :content="payNotifyContent"
      @goPay="onPayNotifyGoPay"
      @goRegister="onPayNotifyGoRegister"
      @close="onPayNotifyClose"
    />
    <!-- 缴费弹窗 -->
    <PayModal :visible="payModalVisible" @close="payModalVisible = false" />
    <!-- 登记弹窗 -->
    <RegisterModal :visible="registerModalVisible" @close="registerModalVisible = false" />
    <!-- 站点缴费说明弹窗 -->
    <a-modal
      :width="680"
      :visible="payDescAlertVisible"
      :maskClosable="false"
      :footer="null"
      @cancel="onPayDescAlertClose"
      wrapClassName="pay-desc-alert-modal-wrap"
    >
      <div class="pay-desc-content" v-html="payDescAlertContent"></div>
    </a-modal>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header';
import InsidePageBannar from '@/common/components/InsidePageBannar';
import InsidePageLeft from '@/common/components/InsidePageLeft';
import Foot from '@/common/components/Foot';
import Fade from '@/common/fade/FadeAnimation';
import MajorList from './components/MajorList';
import SecuritySetting from './components/SecuritySetting';
import EnrollmentSwitch from '@/common/components/EnrollmentSwitch.vue';
import PayNotifyModal from '@/pages/home/components/PayNotifyModal.vue';
import PayModal from '@/pages/home/components/PayModal.vue';
import RegisterModal from '@/pages/home/components/RegisterModal.vue';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'PersonalCenters',
  components: {
    HomeHeader,
    InsidePageBannar,
    Foot,
    MajorList,
    InsidePageLeft,
    Fade,
    SecuritySetting,
    EnrollmentSwitch,
    PayNotifyModal,
    PayModal,
    RegisterModal,
  },
  data: function() {
    return {
      arrs: [],
      sex: true,
      showSwitchBtn: false, // 是否展示切换学籍按钮
      switchModalVisible: false, // 学籍切换组件展示状态
      payNotifyVisible: false,
      payNotifyContent: '',
      payModalVisible: false,
      registerModalVisible: false,
      payDescAlertVisible: false,
      payDescAlertContent: '',
    };
  },
  methods: {
    /**
     * 检查学生是否存在多学籍情况
     */
    checkEnrollmentCount() {
      this.axios
        .get('/biz/archive/getEnrollmentList')
        .then(res => {
          if (res.success && res.result && res.result.length > 1) {
            this.showSwitchBtn = true;
          } else {
            this.showSwitchBtn = false;
          }
        })
        .catch(() => {
          this.showSwitchBtn = false;
        });
    },

    /**
     * 显示多学籍切换弹框
     */
    openSwitchModal() {
      this.switchModalVisible = true;
    },

    /**
     * 点击缴费导航链接 - 已缴费直接跳转，未缴费先检查缴费通知
     */
    gotoPayment() {
      // 已缴费，直接跳转
      if (this.userInfo.feeFlag) {
        this.$router.push('/personalcenters/payment');
        return;
      }
      // 先检查站点缴费说明弹窗（手动触发，跳过token已弹校验）
      this.axios
        .get('/biz/user/pay/payDescAlertCheckManual')
        .then(res => {
          // 必办项校验：有必办项时提示并跳转待办列表
          if (res.code === 200 && res.result && res.result.mustDeal) {
            this.handleMustDeal(res.result.mustDeal);
            return;
          }
          if (res.code === 200 && res.result && res.result.show) {
            this.payDescAlertContent = res.result.content;
            this.payDescAlertVisible = true;
          } else {
            // 无站点缴费说明，继续检查缴费通知
            this.axios
              .get('/biz/user/pay/notifyCheckManual')
              .then(res2 => {
                // 必办项校验：有必办项时提示并跳转待办列表
                if (res2.code === 200 && res2.result && res2.result.mustDeal) {
                  this.handleMustDeal(res2.result.mustDeal);
                  return;
                }
                if (res2.code === 200 && res2.result && res2.result.show) {
                  this.payNotifyContent = res2.result.content;
                  this.payNotifyVisible = true;
                } else {
                  this.$router.push('/personalcenters/payment');
                }
              })
              .catch(() => {
                this.$router.push('/personalcenters/payment');
              });
          }
        })
        .catch(() => {
          // 异常时降级：继续检查缴费通知
          this.axios
            .get('/biz/user/pay/notifyCheckManual')
            .then(res => {
              // 必办项校验：有必办项时提示并跳转待办列表
              if (res.code === 200 && res.result && res.result.mustDeal) {
                this.handleMustDeal(res.result.mustDeal);
                return;
              }
              if (res.code === 200 && res.result && res.result.show) {
                this.payNotifyContent = res.result.content;
                this.payNotifyVisible = true;
              } else {
                this.$router.push('/personalcenters/payment');
              }
            })
            .catch(() => {
              this.$router.push('/personalcenters/payment');
            });
        });
    },
    /**
     * 必办项处理：与 /mustDeal/check 弹出提示样式一致，提示后跳转待办列表
     */
    handleMustDeal(mustDeal) {
      if (mustDeal === 1) {
        this.$message.error('您还有未处理的必办事项！');
      } else if (mustDeal === -1) {
        this.$message.error('请耐心等待必办审核完成！');
      }
      this.$router.push('/todos/list');
    },

    // 关闭站点缴费说明弹窗
    onPayDescAlertClose() {
      this.payDescAlertVisible = false;
    },

    // 缴费通知弹窗按钮事件
    onPayNotifyGoPay() {
      this.payNotifyVisible = false;
      this.payModalVisible = true;
    },
    onPayNotifyGoRegister() {
      this.payNotifyVisible = false;
      this.registerModalVisible = true;
    },
    onPayNotifyClose() {
      this.payNotifyVisible = false;
      // 关闭弹窗，不跳转
    },

    handleGetDataSucc(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.arrs = data.course;
      }
    },
  },
  mounted() {
    this.checkEnrollmentCount();
  },
  computed: {
    ...mapState(['userInfo', 'homeObj']),
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.page-width{
  width:$pageWidth;
  margin:0 auto;
}
.content{
  margin-top:30px;
  background:#fff;
  padding:28px;
  margin-bottom:30px;
  min-height:500px;
  .col-md-2{
    min-height:500px;
    border-right:3px solid #edeff5;
    text-align:center;
    .active{
      background:$bgColor;
      color:#fff;
    }

  }
}
.centerli{
  background:$bgcontent;
  border-radius:10px;
  padding-bottom:30px;
  overflow:hidden;
  padding-top:20px;
  .centerli-top{
    padding:15px 0;
    font-size:18px;
    color:$bgColor;
    font-weight:bold;
  }
  li{
    margin:0px 10px;
    a{
      display:inline-block;
      width:100%;
      padding:15px 0;
      border-bottom:1px solid  #eaeaea;
      color:#999;

    }
  }
  .payment-nav-link{
    cursor:pointer;
    &:hover{
      text-decoration:none;
    }
  }
}
h1{
  font-size:24px;
  margin-bottom:10px;
  margin-top:20px;
  .grade{
    font-size:15px;
    margin-left:12px;
    color:#666;
  }
}
.personalimg{
  img{
    width:112px;
    height:125px;
  }
}
.mymajor{
  color:#999;
  margin-bottom:14px;
}

.enroll-switch {
  font-size: 14px;
  background-color: #f2f3f5;
  border-radius: 20px;
  padding: 4px 12px;
  display: inline-flex;
  align-items: center;
  height: 30px;

  .ant-btn-link {
    display: inline-flex;
    align-items: center;
    padding: 0;
    height: auto;

    .anticon {
      display: inline-flex;
      align-items: center;
      margin-right: -4px; // 图标与文字间距，可调整
      font-size: 14px;
    }
    span {
      line-height: 1;
      font-size: 14px;
    }
  }
}

.pay-desc-content {
  font-size: 15px;
  margin-top: 20px;
  overflow-x: auto;
}

.pay-desc-alert-modal-wrap .ant-modal-header {
  border-bottom: 1px solid #e8e8e8;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/Index.vue